.wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.label {
    font-family: monospace;
    font-weight: 600;
    font-size: 14px;
    color: rgb(50, 49, 48);
    padding-bottom: 2px;
}

/* Input box that looks like a form field */
.inputBox {
    display: flex;
    align-items: center;
    min-height: 36px;
    border: 1px solid rgb(200, 198, 196);
    border-radius: 4px;
    padding: 4px 4px 4px 8px;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.15s ease;
}

.inputBox:hover {
    border-color: rgb(96, 94, 92);
}

.inputBoxOpen {
    border-color: rgb(0, 120, 212);
    border-width: 2px;
    padding: 3px 3px 3px 7px;
}

.inputContent {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    flex: 1;
    align-items: center;
    min-height: 28px;
}

.placeholder {
    font-family: monospace;
    font-size: 13px;
    color: rgb(160, 158, 156);
    user-select: none;
}

.searchInput {
    border: none;
    outline: none;
    font-family: monospace;
    font-size: 13px;
    color: rgb(50, 49, 48);
    background: transparent;
    min-width: 60px;
    flex: 1;
    padding: 2px 0;
}

/* Chips inside the input */
.chip {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 4px 3px 10px;
    border: 1.5px solid rgb(50, 49, 48);
    border-radius: 16px;
    background: #fff;
    font-family: monospace;
    font-size: 12px;
    color: rgb(50, 49, 48);
    line-height: 1.2;
    white-space: nowrap;
    max-width: 180px;
}

.chipText {
    overflow: hidden;
    text-overflow: ellipsis;
}

.chipRemove {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    padding: 0;
    margin: 0;
    border: none;
    border-radius: 50%;
    background: transparent;
    color: rgb(50, 49, 48);
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    cursor: pointer;
    transition: background 0.1s ease;
}

.chipRemove:hover {
    background: rgb(237, 235, 233);
}

/* Chevron arrow */
.chevron {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: center;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: rgb(96, 94, 92);
    cursor: pointer;
    padding: 0;
    transition: transform 0.2s ease;
}

.chevronOpen {
    transform: rotate(180deg);
}

/* Dropdown panel */
.dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: #fff;
    border: 1px solid rgb(200, 198, 196);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    margin-top: 4px;
    max-height: 240px;
    overflow-y: auto;
    padding: 8px;
}

.optionsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.noResults {
    font-family: monospace;
    font-size: 12px;
    color: rgb(160, 158, 156);
    padding: 8px 4px;
    display: block;
}

/* Options shown as pill buttons */
.optionChip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    border: 1.5px solid rgb(200, 198, 196);
    border-radius: 18px;
    background: #fff;
    font-family: monospace;
    font-size: 12px;
    color: rgb(50, 49, 48);
    cursor: pointer;
    transition: all 0.12s ease;
    white-space: nowrap;
}

.optionChip:hover {
    border-color: rgb(50, 49, 48);
    background: rgb(250, 249, 248);
}

.optionChipSelected {
    border-color: rgb(50, 49, 48);
    background: rgb(243, 242, 241);
    font-weight: 600;
}

.optionCheck {
    font-size: 10px;
    font-weight: 700;
    color: rgb(96, 94, 92);
    margin-left: 2px;
}
